export default {
  '/board/:public_slug': 'acts',
  '/board/:public_slug/:highlight_slug': 'acts',
  '/board/:public_slug/tiles': 'tiles tiles-index',
  '/board/:public_slug/tile/:id': 'tiles tiles-show',
  '/ard/:public_slug/activity': 'acts',
  '/tiles': 'tiles tiles-index',
  '/tile/:id': 'tiles tiles-preview',
  '/ard/:public_slug/tiles': 'tiles tiles-index',
  '/tiles/:id': 'tiles tiles-show',
  '/explore': 'explore explore-index',
  '/explore/audiences/:audience': 'explore explore-index',
  '/explore/tile/:id': 'explore tiles-preview',
  '/client_admin/tiles':
    'client_admin-tiles client_admin-tiles-index client_admin_main',
  '/client_admin/changelog/:id':
    'client_admin-changelog client_admin-changelog-show client_admin_main',
  '/client_admin/changelog':
    'client_admin-changelog client_admin-changelog-show client_admin_main',
};
